import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { __ } from '../../../../helpers/translations';
import ReviewNameModal from '../modals/ReviewNameModal';

function EditReviewNameButton({ review, onChanged }) {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Button
        title={__('G267')}
        size="md"
        variant="light"
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon icon={faPencilAlt} />
      </Button>
      {showModal && (
      <ReviewNameModal
        name={review.name}
        onChanged={async () => {
          await onChanged();
          setShowModal(false);
        }}
        onCancel={() => setShowModal(false)}
        reviewId={review.reviewId}
      />
      )}
    </>

  );
}

EditReviewNameButton.propTypes = {
  review: PropTypes.shape({
    reviewId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onChanged: PropTypes.func,
};

export default EditReviewNameButton;
